import React from 'react';
import Home from './component/home';


import './App.css';

function App()   {
  return (
    <div class="overflow-hidden " >
    <Home />
    </div>
    );
}
  

export default App;
